import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchTodolists(params) {
  return dispatch => {
    dispatch({type: "FETCH_TODOLISTS", data: []});
    myGet(dispatch, servAddr + 'todolist', {params}).then((response) => {
      dispatch({type: "FETCH_TODOLISTS", data:response.data});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function fetchDefaultTodolists() {
  return dispatch => {
    myGet(dispatch, servAddr + 'todolist', {
      params: {order_id: 0}
    }).then((response) => {
      dispatch({type: "FETCH_DEFAULT_TODOLISTS", data:response.data});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function fetchCalendarTodolists() {
  return dispatch => {
    myGet(dispatch, servAddr + 'todolist', {
      params: {calendar: 1}
    }).then((response) => {
      dispatch({type: "FETCH_CALENDAR_TODOLISTS", payload: response.data});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function editTodolist(todolist, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights.todolist_post === 1 ? 'todolist' :
    'todolist_assigned';
  return dispatch => {
    myPost(dispatch, servAddr + model, {data: todolist}).then((response) => {
      if (todolist.todolist_id) {
        cb();
        dispatch({type: "EDIT_TODOLIST", payload: response.data.updated});
      }
      else {
        cb();
        if (!todolist.duplicate) {
          dispatch({
            type: "CREATE_TODOLIST",
            payload: {
              ...todolist,
              todolist_id: response.data.id
            }
          });
        }
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/todolistActions.js